<template>
  <div>
      <div class="attrlist">
          <el-checkbox-group v-model="checkLists" class="checkclass">
            <el-checkbox 
              class="attrlistitem" 
              v-for="(item,index) in checkboxList" 
              :key="index" 
              :label="item.id"
              @change="onchange(index,type)"
              >
              {{item.name}}
            </el-checkbox>
          </el-checkbox-group>
      </div>
  </div>  
</template>

<script>
export default {
   data() {
      return {
        checkLists: this.checkList,
      };
    },
    props:{
      type: {
        type: String,
        default: "attr"
      },
      checkboxList:{
        type: Array,
        default: function () {
         return [] 
        }
      },
      index:{
        type:Number,
        default:0
      },
      checkList:{
        type: Array,
        default: function () {
         return [] 
        }
      },
    },
    watch:{
      checkList(val,oldval){
        this.checkLists = val;
      }
    },
    methods:{
      onchange(val){
        //通知父组件 父组件通途分类id+type来区分
        if(this.type=="class"){
          //获取attr
          this.$emit('changeList',val)
        }else{
          //获取商品列表          
          this.$emit('changTab',val,this.index);
        }
      },
      
    },
}
</script>

<style scoped>
  .checkclass >>> .el-checkbox__input.is-checked .el-checkbox__inner:after{
    /* transform: rotate(
0deg); */
    -moz-transform: none;
    -webkit-transform: none;
    -o-transform: none;
    -ms-transform: none;
    transform: none;
    -webkit-transition:none;
    transition:none;
    border-radius: 50%;
    border: 0 solid;
    background-color: #FBB113;
    height:8px;
    width: 8px;
    left: 2px;
    top: 2px;
  }
  .attrlist >>> .el-checkbox__inner{
    border:1px solid #666666;
    border-radius:50%;
  }
  .attrlist >>> .el-checkbox__inner:hover{
    border:1px solid #FBB113;
  }
  .attrlist >>> .el-checkbox__input.is-focus .el-checkbox__inner{
    border:1px solid #666666;
  } 
  .attrlist >>> .el-checkbox__input.is-checked .el-checkbox__inner, .attrlist >>> .el-checkbox__input.is-indeterminate .el-checkbox__inner{
    background-color:#fff;
  }
  .attrlist >>> .el-checkbox__input.is-checked .el-checkbox__inner{
    border:1px solid #FBB113;
    border-radius:50%;
  }
  .attrlist >>> .el-checkbox__input.is-checked+.el-checkbox__label{
    color:#444444;
  }
  .attrlist{
    width: 216px;
    background-color: #F4F5F7;
    border-radius: 3px;
  }
  .attrlistitem{
    width: 222px;
    margin-left: 12px;
    margin-top: 10px;
    font-size: 14px;
    color: #444444;
  }
  .attrlistitem:last-child{
    margin-bottom: 10px;
  }
</style>


// WEBPACK FOOTER //
// src/components/goods/GoodsSearch.vue